'use strict';

/*------------------------------------*\
 * JS Main entry file
 \*------------------------------------*/
import './config';

// Import utilities.
import '@utilities/in-view';

// Import Singletons
import '@utilities/detect-touch';
import 'lazysizes';

var myNodeList = document.querySelectorAll('[js-hook-slider]');

[].forEach.call(myNodeList, function (item) {
    tns({
        container: item,
        "item": 1,
        "gutter": 10,
        "mouseDrag": true,
        slideBy: 'page'
      });
});




// WEBPACK FOOTER //
// /Users/sandersturing/Sites/EXT/hannelore/frontend/source/javascript/main.js